import { Qrcode } from '@/typings/types';
import { TextRenderer } from '@/common/utils/textRenderer';
import { ProductsTitle, SectionTitle } from '@/common/titles';
import SlideUp from '@/common/utils/slideUp';

type BuchesProps = {
  buches: Qrcode['buches'];
};

const Buches = ({ buches }: BuchesProps) => {
  const { title, introduction, items } = buches ?? {};

  const Products = items?.map((item) => {
    const { title, description, id } = item ?? {};
    return (
      title && (
        <SlideUp key={id} yOffset={25} delay delayDuration={150}>
          <dl className={'flex flex-col items-start justify-start mb-5'}>
            <ProductsTitle title={title} />
            <dd className={'lg:w-10/12 leading-[24px] text-lg font-libertineRegular'}>
              {description}
            </dd>
          </dl>
        </SlideUp>
      )
    );
  });
  return (
    <section className={'flex flex-col justify-start mx-auto max-w-6xl'}>
      {title && <SectionTitle title={title} />}
      {introduction && <TextRenderer text={introduction} as={'div'} />}
      <div className={'flex flex-col gap-y-5 mt-14'}>{Products}</div>
    </section>
  );
};

export default Buches;
